import { JSX } from 'react';
import { GamificationIcon, GamificationIconType } from '@bg-components/GamificationIcon';
import { GamificationNotificationType } from '@bg-shared';

interface IProps {
    type: GamificationNotificationType;
    className?: string;
}

export const NotificationIcon = (props: IProps): JSX.Element => {
    if (props.type === GamificationNotificationType.CHALLENGE) {
        return <GamificationIcon className={props.className} icon={GamificationIconType.BADGE} />;
    }

    return <GamificationIcon className={props.className} icon={GamificationIconType.INBOX} />;
};
